import { render, staticRenderFns } from "./resumo-habilitador.vue?vue&type=template&id=de4c79ce&scoped=true"
import script from "./resumo-habilitador.vue?vue&type=script&lang=js"
export * from "./resumo-habilitador.vue?vue&type=script&lang=js"
import style0 from "./resumo-habilitador.vue?vue&type=style&index=0&id=de4c79ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4c79ce",
  null
  
)

export default component.exports